import { format } from "date-fns";
import { Field, Formik, Form } from "formik";
import { Fragment } from "react";

import { getMostRecentQAReview } from "components/admin/adminUtils";
import { PathologyWatchButton } from "components/customInputs/buttons/Button";
import { ControlledToggleButton } from "components/customInputs/buttons/ToggleButton";
import TextareaInput from "components/customInputs/TextareaInput";

import { QAReviewsProps } from "./qaReviewPanel";

const QAReviewForm = ({
  qaReviews,
  caseId,
  onClose,
  onSubmit,
}: QAReviewsProps) => {
  const mostRecentReview = getMostRecentQAReview(qaReviews);

  const handleOnSubmit = (values: any, isNote?: boolean) => {
    const payload = {
      caseId: caseId,
      note: values.note,
      reviewed: isNote
        ? !!mostRecentReview?.reviewed
        : !mostRecentReview?.reviewed,
      onClose,
    };
    onSubmit(payload);
  };

  return (
    <Formik
      initialValues={{ note: "" }}
      enableReinitialize
      onSubmit={(values) => handleOnSubmit(values)}
    >
      {({ values }) => (
        <Form className="AdminPanelForm">
          <div className="panelContainer">
            <Field name="note">
              {({ field }: any) => (
                <TextareaInput label="Note" rows={4} {...field} />
              )}
            </Field>
            <fieldset
              className="panelContainer__section"
              style={{ gap: "0.2em" }}
            >
              <legend className="panelContainer__section--title">
                QA Review Logs
              </legend>
              {qaReviews &&
                qaReviews
                  .sort((a, b) =>
                    (a.created_at || "") > (b.created_at || "") ? -1 : 1
                  )
                  .map((review) => (
                    <Fragment key={review.id}>
                      <span style={{ maxWidth: "100%" }}>
                        {review.created_at
                          ? format(
                              new Date(review.created_at),
                              "MM-dd-yyyy h:mm a"
                            )
                          : ""}{" "}
                        {review.user
                          ? `${review.user.first_name} ${review.user.last_name}`
                          : ""}
                        :{" "}
                        {review.reviewed
                          ? "Completed a QA review"
                          : "Removed a QA Review"}
                      </span>
                      {review.note && (
                        <span
                          style={{ marginLeft: "20px" }}
                          className="text--raw text--overflow"
                        >
                          {review.note}
                        </span>
                      )}
                    </Fragment>
                  ))}
            </fieldset>
          </div>
          <footer>
            <PathologyWatchButton onClick={() => onClose()}>
              Cancel
            </PathologyWatchButton>
            <div className="panelContainer__inputGroup">
              <PathologyWatchButton
                onClick={() => handleOnSubmit(values, true)}
                color={qaReviews?.length ? "grey" : "red"}
              >
                {qaReviews?.length ? "Add Note" : "Hold Case"}
              </PathologyWatchButton>
              <ControlledToggleButton
                isToggled={!!mostRecentReview?.reviewed}
                colors={{
                  on: "red",
                  off: "green",
                }}
                type="submit"
              >
                {mostRecentReview?.reviewed ? "Hold Case" : "Add QA Review"}
              </ControlledToggleButton>
            </div>
          </footer>
        </Form>
      )}
    </Formik>
  );
};

export default QAReviewForm;
